import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useRecoilValue } from "recoil";

import { currentPageState } from "../../state/app";

import { SEOProps } from "./SEO.types";

declare global {
    interface Window {
        dataLayer: {
            pageName?: string;
            event?: string;
            applicationName?: string;
            applicationLanguage?: string;
            applicationCountry?: string;
        }[];
    }
}

const SEO: React.FC<SEOProps> = ({ language, title }) => {
    const page = useRecoilValue(currentPageState);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        if (
            page &&
            window.dataLayer &&
            window.dataLayer[window.dataLayer.length - 1]?.pageName !==
                page.name
        ) {
            window.dataLayer.push({
                event: "pageInformation",
                applicationName: "LG Ford",
                pageName: page.name,
                applicationLanguage: process.env.GATSBY_CURRENT_LANGUAGE,
                applicationCountry: "BE",
            });
        }
    }, [page]);

    useEffect(() => {
        // Avoid destructive re-hydration by stalling GTM
        setIsClient(true);
    }, []);

    return (
        <>
            <Helmet htmlAttributes={{ lang: language, title }}>
                <title>{title}</title>

                {isClient && (
                    <script
                        id="ga4"
                        type="text/javascript"
                        src="/scripts/analytics.js"
                    />
                )}
            </Helmet>

            <noscript>
                <iframe
                    src="https://www.googletagmanager.com/ns.html?id=GTM-MKZQH88N"
                    height="0"
                    width="0"
                    style={{ display: "none", visibility: "hidden" }}
                ></iframe>
            </noscript>
        </>
    );
};

export default SEO;
